
















import { Component, Mixins, Prop } from "vue-property-decorator";
import { MenuPane } from "../../../../panes";
import { ModelEditableMixin } from "../../../../system/mixins";
import {
  ExtraDocumentAccessibleMixin,
  CommonComponentsAccessibleMixin,
} from "../../mixins";

@Component({
  components: {
    MenuPane,
  }
})
export default class ExtraPageMenu extends Mixins(
  ModelEditableMixin,
  ExtraDocumentAccessibleMixin,
  CommonComponentsAccessibleMixin,
) {
  @Prop({ default: false })
  isHorizontal: boolean;

  get addButtonTooltipMessage(): string {
    return this.isExtendedPagePositionSelectable
      ? "指定するページに続紙を追加します。"
      : "最終ページの次に続紙を追加します。";
  }

  get className(): string {
    return this.isHorizontal ? "horizontal-extra-page-menu-root" : "vertical-extra-page-menu-root";
  }

  get classNameTooltipAddButton(): string {
    return this.isHorizontal ? "" : "vertical-extra-page-menu-tooltip-add-botton-content";
  }

  get classNameTooltipRemoveButton(): string {
    return this.isHorizontal ? "" : "vertical-extra-page-menu-tooltip-remove-botton-content";
  }

  add(): void {
    this.commonComponents.editors.extraPage.addExtraPageAfterCurrentPage();
  }

  remove(): void {
    this.commonComponents.editors.extraPage.removeCurrentPage();
  }
}
